import React, { Component } from 'react';

import type { UserProductGroup } from '~/Api/User/ProductGroup';

interface Props {
	selected: boolean;
	disableAutoScroll: boolean;
	children: React.ReactNode;
	prompt?: React.ReactNode;
	value: string | number | null | UserProductGroup;
	hasSubOptions?: boolean;
	styles: { selectedOption: string | null; defaultOption: string | null };
	onClick(segment: SegmentedSelectOption): void;
}

export default class SegmentedSelectOption extends Component<Props> {
	static defaultProps = {
		selected: false,
		disableAutoScroll: false,
		styles: { selectedOption: null, defaultOption: null },
		onClick: () => undefined,
	};

	handleRef = (ref: HTMLLIElement | null) => {
		if (ref) {
			ref.scrollIntoView(false);
		}
	};

	render() {
		const { selected, disableAutoScroll, children, styles, onClick } = this.props;

		return (
			<li
				className={(selected ? styles.selectedOption : styles.defaultOption) || ''}
				data-testid='segmented-select-option'
				ref={selected && !disableAutoScroll ? this.handleRef : null}
				role='menuitem'
				onClick={() => onClick(this)}
			>
				{children}
			</li>
		);
	}
}
